import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Formio, FormioModule, FormioAppConfig } from '@formio/angular';
import { FormsModule } from '@angular/forms';
import { FormioGrid } from '@formio/angular/grid';
import { FormioAuthService, FormioAuthConfig } from '@formio/angular/auth';
import { FormioResources } from '@formio/angular/resource';
import { PrismService } from './Prism.service';

import { AppConfig } from './config';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { DataComponent } from './data/data.component';
import { ParserService} from './Services/parser.service';
import { HttpClientModule } from '@angular/common/http';
import { RequestsService } from './Services/requests.service';
import { LoginComponent } from './components/login/login.component';
import { RegistroComponent } from './components/registro/registro.component';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSnackBarModule} from '@angular/material/snack-bar';
import { FormrendererComponent } from './components/formrenderer/formrenderer.component';
import { RendererComponent } from './forms/renderer/renderer.component';
import { AuthGuard } from './auth.guard';
import { ListformsComponent } from './components/listforms/listforms.component';
import { EditformComponent } from './components/editform/editform.component';

import { FORMS } from './forms/forms.index';
import { FormsComponent } from './forms/forms/forms.component';
import { SimpleComponent } from './forms/simple/simple.component';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule} from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatTableModule } from "@angular/material/table";
import { HeaderComponent } from './components/header/header.component';
import { RequestPasswordComponent } from './components/request-password/request-password.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ListusersComponent } from './components/listusers/listusers.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { EditUserComponent } from './components/edit-user/edit-user.component';
import { V3Component } from './components/facephi/v3/v3.component';
//import { HeaderformComponent } from './components/headerform/headerform.component';

import '@facephi/selphi-widget-web'
import '@facephi/selphid-widget-web';
import { V5Component } from './components/facephi/v5/v5.component'

// Make sure we use fontawesome everywhere in Form.io renderers.
(Formio as any).icons = 'fontawesome';


/**
 * Import the Custom component CheckMatrix.
 */
// import './components/CheckMatrix';
const modules = [
  MatButtonModule,
  MatFormFieldModule,
  MatInputModule,
  MatCheckboxModule,
  MatTableModule,
  MatPaginatorModule
];


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    DataComponent,
    LoginComponent,
    RegistroComponent,
    FormrendererComponent,
    ListformsComponent,
    EditformComponent,
    FormsComponent, 
    SimpleComponent, 
    HeaderComponent, 
    RequestPasswordComponent, 
    ListusersComponent, ForgotPasswordComponent, EditUserComponent, V3Component, V5Component,
    // HeaderformComponent,

  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormioModule,
    FormioGrid,
    HttpClientModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    BrowserAnimationsModule,
    FormsModule,
    RouterModule.forRoot([
      {
        path:'', redirectTo:'login', pathMatch:'full'
      },
      {
        path: 'ini',
        component:ListformsComponent,
        canActivate: [AuthGuard]
      },
      /*{
        path: '',
        component: LoginComponent
      },*/

      {
        path: 'forms',
        loadChildren: () => import('./forms/forms.module').then(m => m.FormsioModule),
        canActivate: [AuthGuard]
      },

      {
        path:'login',
        component: LoginComponent
      },
      {
        path:'login/olvidar-contrasena',
        component: RequestPasswordComponent
      },
      {
        path: 'login/cambiar-contrasena/:token',
        component: ForgotPasswordComponent
      },
      {
        path:'registro',
        component: RegistroComponent,
        canActivate: [AuthGuard]
      },
      {
        path:'login/registro',
        component: RegistroComponent,
        canActivate: [AuthGuard]
      },
      {
        path:'render/:nombre',
        component: FormrendererComponent,
        //canActivate: [AuthGuard]
      },
      {
        path:'edit/:nombre',
        component: EditformComponent,
        canActivate: [AuthGuard]
      },
      {
        path:'list-users',
        component: ListusersComponent,
        canActivate: [AuthGuard]
      },
      {
        path:'editUser/:id',
        component: EditUserComponent,
        canActivate:[AuthGuard]

      },
      {
        path:'documentv3',
        component: V3Component
      },
      {
        path:'documentv5',
        component: V5Component
      }
    ], {useHash: true}),
    modules
  ],
  providers: [
    PrismService,
    FormioAuthService,
    FormioResources,
    ParserService,
    RequestsService,
    {provide: FormioAppConfig, useValue: AppConfig},
  ],
  exports:[
    //HeaderComponent
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
